import React from 'react';
import Clickable from 'components/Clickable';
import './Icon.scss';

/**
 * An utility components simplifying icon usage for mobile. Encapsulate common icon styles.
 *
 * @param {SVG} icon
 * @param {String} className
 * @param {Array} props
 */
const Icon = ({ icon, className, ...props }) => (
  <Clickable className={`icon-wrapper ${className}`} tabIndex="-1" {...props}>
    <img src={icon} alt="" />
  </Clickable>
);

export default Icon;
